import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { FINDER_HEADLINE, finderSteps, problemGroups } from '../data/poolContent';
export function ProblemFinderSection() {
  return <section className="w-full bg-abyss-900 py-14 sm:py-20" aria-labelledby="finder-title" data-id="element-283" data-mp="343zr95bikyq3">
      <div className="mx-auto max-w-6xl px-5" data-id="element-284" data-mp="2z56drcw897px">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[0.22em] text-aqua" data-id="element-285" data-mp="2z4et2x464uef">
          Problem finder
        </p>
        <h2 id="finder-title" className="mx-auto mt-3 max-w-3xl text-center font-display text-[2.1rem] font-bold uppercase leading-none text-frost-50 sm:text-[3rem]" data-id="element-286" data-mp="3d2l4qm24pnk0">
          {FINDER_HEADLINE}
        </h2>

        <div className="mt-12 grid gap-10 lg:grid-cols-2 lg:gap-x-12" data-id="element-287" data-mp="3hve9vb1iexwm">
          {problemGroups.map(g => <div key={g.group} data-id="element-288" data-mp="olwa5bmc123">
              <h3 className="flex items-center gap-2.5 border-b border-abyss-600 pb-3 text-[12px] font-semibold uppercase tracking-[0.18em] text-frost-200" data-id="element-289" data-mp="nsqb6khhfl0">
                <span className="h-2.5 w-2.5 rounded-full" style={{
              backgroundColor: g.swatch
            }} aria-hidden="true" data-id="element-290" data-mp="wmtrbuggjaoa" />
                {g.group}
              </h3>
              <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-291" data-mp="15lf418z8zvh5">
                {g.problems.map(p => <li key={p} className="flex items-center justify-between gap-3 rounded-xl border border-abyss-600 bg-abyss-800 py-3.5 pl-4 pr-3" style={{
              borderLeftColor: g.swatch,
              borderLeftWidth: 3
            }} data-id="element-292" data-mp="1an4eonik674p">
                    <span className="font-display text-[1.15rem] font-semibold uppercase leading-tight tracking-[0.02em] text-frost-50" data-id="element-293" data-mp="1pb91o3on94ta">
                      {p}
                    </span>
                    <ArrowRightIcon className="h-4 w-4 shrink-0 text-pool" strokeWidth={2} aria-hidden="true" data-id="element-294" data-mp="1ycqcp7n72gb4" />
                  </li>)}
              </ul>
            </div>)}
        </div>

        <ol className="mx-auto mt-12 flex max-w-3xl flex-col items-center justify-center gap-2 text-center sm:flex-row sm:gap-4" data-id="element-295" data-mp="3ufv2yjykiqjk">
          {finderSteps.map((s, i) => <li key={s} className="flex items-center gap-4" data-id="element-296" data-mp="872agd3ny2zp" data-mpi={i}>
              <span className="font-display text-[1.35rem] font-bold uppercase text-aqua" data-id="element-297" data-mp="85itsle3hpxe">{s}</span>
              {i < finderSteps.length - 1 && <span className="hidden text-pool/60 sm:inline" aria-hidden="true" data-id="element-298" data-mp="hw3q226aqid5">
                  →
                </span>}
            </li>)}
        </ol>
      </div>
    </section>;
}